module.exports = __webpack_public_path__ + "img/img71.881b131d.png";